package br.com.texeratx.boardgametimeapp.ui.screens.forgot_password

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.screens.reset_password.ResetPasswordScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.getScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

class ForgotPasswordScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = getScreenModel<ForgotPasswordViewModel>()
        val state by viewModel.state.collectAsState()

        ForgotPasswordUI(
            state = state,
            onEmailChange = viewModel::updateEmail,
            onSubmitClick = viewModel::submit,
            onGoToResetPassword = { navigator.push(ResetPasswordScreen(email = state.email)) },
            onBack = { navigator.pop() }
        )
    }
}
